// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screen[data-v-8386ab9a]{width:100%;height:100%;position:absolute;top:0;left:0}.screen--fit[data-v-8386ab9a]{object-fit:contain}.screen--fill[data-v-8386ab9a]{object-fit:cover}\n", ""]);
// Exports
module.exports = exports;
